export const fieldNames = {
  exportTypeId: 'exportTypeId',
  exportParams: 'exportParams',
};

export const fieldTypes = {
  int: 'int',
  string: 'string',
  bool: 'bool',
  dateRange: 'daterange',
  address: 'address',
  service: 'service',
};
